import { Announced, SearchBox } from "@fluentui/react";
import * as React from "react";

export function FilterField(props) {
  return (
    <>
      <Announced message={props.message} />
      <Announced
        message={`Number of items after filter applied: ${props.items.length}.`}
      />
      <SearchBox
        onChange={props.onChange}
        placeholder="Search"
        iconProps={{ iconName: 'Filter' }}
        {...props.textFieldProps}
      />
    </>
  );
}
